import { DaysOfWeek } from 'enums';

/** API sentinel for “runs every day” (single-element array). */
export const API_DAYS_OF_WEEK_ALL = 'ALL';

export const WEEKDAY_DAYS: DaysOfWeek[] = [
  DaysOfWeek.MON,
  DaysOfWeek.TUE,
  DaysOfWeek.WED,
  DaysOfWeek.THU,
  DaysOfWeek.FRI
];

export const WEEKEND_DAYS: DaysOfWeek[] = [DaysOfWeek.SAT, DaysOfWeek.SUN];

/**
 * Canonical “runs every day” for habits and scheduled custom routines.
 * API uses the same MON–SUN tokens as {@link DaysOfWeek}.
 */
export const ALL_DAYS_OF_WEEK: DaysOfWeek[] = [
  ...WEEKDAY_DAYS,
  ...WEEKEND_DAYS
];

export const WEEKLY_SCHEDULE_TOGGLE = {
  WEEKDAYS: 'Weekdays',
  WEEKEND: 'Weekend'
} as const;
